import { render, staticRenderFns } from "./VerifyPoints.vue?vue&type=template&id=73830772&"
import script from "./VerifyPoints.vue?vue&type=script&lang=js&"
export * from "./VerifyPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports